import './App.css';
import Login from './components/Login';
import useLoggedIn from './hooks/useLoggedIn';
import ItemView from './components/ItemView';
import { useLocalStorage } from "usehooks-ts";

function App() {
  const [partindex, setPartindex] = useLocalStorage("part-index", 0);
  let { isLoggedIn, setLoggedIn, password, tryLogin, logout, item, message, setMessage } = useLoggedIn();
  return (
    <>
      <header className=" Flex Lightgray Pad05 ">
        <div className="Flex SpaceBetween MaxWidth60 Flex1">
          <div className="Logo Flex Flex1">
            <img src="/assets/logo.png" alt="Körakademin logo" />
            <h2>Körakademin</h2>
          </div>
          <Login tryLogin={tryLogin} password={password} logout={logout} setMessage={setMessage} />
        </div>
      </header>
      <div className="App Container">
        {message && <p className="Message">{message}</p>}
        <ItemView item={item} partindex={partindex} setPartindex={setPartindex} />
      </div>
    </>
  );
}

export default App;
